import Dashboard from "views/DashboardNew.jsx";

import Video from "views/Video.jsx";
import Zoom from "views/Zoom.jsx";
import Subscription from "views/Subscription.jsx";
import PaymentForm from "views/PaymentForm.jsx";
import SubSuccess from "views/SubSuccess.jsx";
import material from "views/Material.jsx";
import prediction from "views/Prediction.jsx";
import Practice from "views/Practice.jsx";
import DailyFeedback from "views/DailyFeedback.jsx";
import DailyTask from "views/DailyTask.jsx";
import session from "views/Session.jsx";
import notification from "views/Notification.jsx";
import DailyTaskAdmin from "views/DailyTaskAdmin.jsx";
import QuestionList from "views/QuestionList.jsx";
import QuestionListWeekly from "views/QuestionListWeekly.jsx";

// import Test from "views/Test.jsx";
import Test from "views/MockTest/Test";
import SectionalTest from "views/SectionalTests/Test";
import FullTest from "views/FullTest.jsx";

import ViewPdf from "views/ViewPdf.jsx";
import Result from "views/Result.jsx";
import Score from "views/Score.jsx";
import ShowVideo from "views/ShowVideo.jsx";
import Mock from "views/Mock.jsx";
import PracticedDetail from "views/PracticedDetail.jsx";
import Template from "views/Template.jsx";
import Help from "views/Help.jsx";
import MockPending from "views/MockPending.jsx";
import MockResult from "views/MockResult.jsx";
import MockAnalysis from "views/MockAnalysis.jsx";
import MockAnalysis1 from "views/MockAnalysis1.jsx";
import Profile from "views/Profile.jsx";
import Transaction from "views/Transaction.jsx";
import Login from "views/pages/Login.jsx";
import ResetPassword from "views/pages/ResetPassword.jsx";
import Forgot from "views/pages/Forgot.jsx";
import Register from "views/pages/Register.jsx";
import Chrome from "views/Chrome.jsx";
import ChromeCheckGlobal from "views/ChromeCheckGlobal.jsx";
import Password from "views/Password.jsx";
import ProgressTracker from "views/ProgressTracker.jsx";
import NotFound from "./page/NotFound";
import NotFoundAdmin from "./page/NotFoundAdmin";
import SpeakingTestingApis from "./views/SpeakingTestingApis";
import PracticeHistory from "views/PracticeHistory";
import Unauthorized from "views/Unauthorized";
import PredictionFiles from "views/PredictionFiles";
import SubscriptionDetail from "views/SubscriptionDetail";
import Plans from "page/plans";
// import Plans from "components/Payments/SuccessCard";
import Notifications from "page/Notifications";
import Check from "views/pages/Check";
import CCA from "views/CCA";
import CancelComponentCCA from "views/CCAvenue/CancelComponentCCA";
import RedirectComponentCCA from "views/CCAvenue/RedirectComponentCCA";
import PaymentCard from "components/Payments/PaymentCard";
import WritingAssessment from "views/WritingAssessment";
import NewMicSetup from "views/NewMicSetup";
import LoginWithCaptcha from "views/pages/LoginWithCaptcha";
import RegisterWithCaptcha from "views/pages/RegisterWithCaptcha";
import SuccessCard from "components/Payments/SuccessCard";

let url_type =
  import.meta.env.VITE_API_URL === "https://backend22.languageacademy.com.au"
    ? 2
    : 1;

const routes = [
  // {
  //   path: "/ccav/plans",
  //   name: "cc avenue payment",
  //   type: 2,
  //   component: CCA,
  //   layout: "/admin",
  // },
  {
    path: "/payment/status",
    name: "Payment Status",
    type: 2,
    component: PaymentCard,
    layout: "/admin",
  },
  {
    path: "/cca/cancel/url",
    name: "cc avenue payment",
    type: 2,
    component: CancelComponentCCA,
    layout: "/admin",
  },
  {
    path: "/cca/redirect/url",
    name: "cc avenue payment",
    type: 2,
    component: RedirectComponentCCA,
    layout: "/admin",
  },
  {
    path: "/unauthorized",
    name: "UnAuthorized Access Restricted",
    type: 2,
    component: Unauthorized,
    layout: "/admin",
  },
  {
    path: "/testingggss",
    name: "Testing apis",
    icon: "fa fa-tachometer",
    component: SpeakingTestingApis,
    layout: "/admin",
    type: url_type,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "fa fa-tachometer",
    component: Dashboard,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/chrome",
    name: "Chrome Speech",
    icon: "fa fa-user",
    component: Chrome,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/progress/:id",
    name: "Chrome Speech",
    icon: "fa fa-user",
    component: ProgressTracker,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/allCheck",
    name: "Chrome Speech",
    icon: "fa fa-user",
    component: ChromeCheckGlobal,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/mic-setup",
    name: "Mic Setup",
    icon: "fa fa-microphone",
    component: NewMicSetup,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/practice-detail",
    name: "Practiced Detail",
    icon: "fa fa-user",
    component: PracticedDetail,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/profile",
    name: "My Profile",
    icon: "fa fa-user",
    component: Profile,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/subscription-detail",
    name: "Subscription Detail",
    icon: "fa fa-user",
    component: SubscriptionDetail,
    layout: "/admin",
    type: 2,
  },
  {
    collapse: true,
    name: "Pages",
    icon: "nc-icon nc-book-bookmark",
    state: "pagesCollapse",
    type: 2,
    views: [
      {
        path: "/check",
        name: "Check",
        mini: "L",
        component: Check,
        layout: "/auth",
      },
      {
        path: "/login",
        name: "Login",
        mini: "L",
        // component: Login,
        component: LoginWithCaptcha,
        layout: "/auth",
      },

      {
        path: "/register",
        name: "Register",
        mini: "R",
        component: RegisterWithCaptcha,
        layout: "/auth",
      },
      {
        path: "/forgot",
        name: "Forgot",
        mini: "R",
        component: Forgot,
        layout: "/auth",
      },
      {
        path: "/ResetPassword",
        name: "ResetPassword",
        mini: "R",
        component: ResetPassword,
        layout: "/auth",
      },
    ],
  },
  {
    path: "",
    name: "Practice Materials",
    icon: "fa fa-search",
    component: material,
    layout: "/admin",
    type: 1,
    state: "pagesCollapse",
    collapse: true,
    views: [
      {
        path: "/test-material",
        name: "Practice Questions",
        icon: "fa fa-file-text",
        component: material,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/monthly-prediction",
        name: "monthly Prediction",
        icon: "fa fa-hourglass-half",
        component: prediction,
        layout: "/admin",
        type: 1,
      },
    ],
  },
  {
    path: "/template",
    name: "Template",
    icon: "fa fa-clipboard",
    component: Template,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "fa fa-bell",
    component: Notifications,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/prediction-files",
    name: "Prediction",
    icon: "fa fa-clipboard",
    component: PredictionFiles,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/sectionalTest",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: SectionalTest,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/test",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: Test,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/fulltest/:id/:pending",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: FullTest,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/viewpdf/:id",
    name: "ViewPdf",
    icon: "nc-icon nc-bank",
    component: ViewPdf,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/result/:id",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: Result,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/scorecard/:type/:id",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: Score,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/analysis/:type/:id",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: MockAnalysis,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/mock-analysis/:id",
    name: "abc",
    icon: "nc-icon nc-bank",
    component: MockAnalysis1,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/video/:id",
    name: "video",
    icon: "nc-icon nc-bank",
    component: ShowVideo,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/practice/:type/:id/:index/:aType/:mark/:attempted/:complexity/:videos",
    name: "practice",
    icon: "nc-icon nc-bank",
    component: Practice,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/practice-hist/:type/:id/:index/:aType/:mark/:attempted/:complexity",
    name: "practice history",
    icon: "nc-icon nc-bank",
    component: PracticeHistory,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/questionList/:type/:id",
    name: "Question List",
    icon: "nc-icon nc-bank",
    component: QuestionList,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/questions-weekly/:type/:id",
    name: "Question Weekly",
    icon: "nc-icon nc-bank",
    component: QuestionListWeekly,
    layout: "/admin",
    type: 2,
  },
  {
    path: "",
    name: "Mock Test",
    icon: "fa fa-pencil-square-o",
    component: Mock,
    layout: "/admin",
    type: 1,
    state: "mockCollapse",
    collapse: true,
    views: [
      {
        path: "/mock",
        name: "Take test",
        icon: "fa fa-check",
        component: Mock,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/pending",
        name: "Pending Test",
        icon: "fa fa-star-half",
        component: MockPending,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/mock-result",
        name: "Test result",
        icon: "fa fa-line-chart",
        component: MockResult,
        layout: "/admin",
        type: 1,
      },
    ],
  },
  {
    path: "",
    name: "Mock Test",
    icon: "fa fa-pencil-square-o",
    component: Mock,
    layout: "/admin",
    type: 1,
    state: "mockCollapse",
    collapse: true,
    views: [
      {
        path: "/extensive/new-sectional-tests",
        name: "New Sectional Tests (Beta)",
        icon: "fa fa-line-chart",
        component: Mock,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/extensive-pending/new-sectional-tests",
        name: "Pending Test",
        icon: "fa fa-star-half",
        component: MockPending,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/results",
        name: "Test result",
        icon: "fa fa-line-chart",
        component: MockResult,
        layout: "/admin",
        type: 1,
      },
    ],
  },
  {
    path: "/videos",
    name: "PTE Secret Strategy Videos",
    icon: "fa fa-youtube-play",
    component: Video,
    layout: "/admin",
    type: 1,
  },
  {
    path: "",
    name: "Daily Goals",
    icon: "fa fa-line-chart",
    component: DailyTask,
    layout: "/admin",
    type: 1,
    state: "dailyCollapse",
    collapse: true,
    views: [
      {
        path: "/daily-task",
        name: "Daily Task",
        icon: "fa fa-list-ul",
        component: DailyTask,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/success-plan",
        name: "Success Plan",
        icon: "fa fa-sticky-note-o",
        component: DailyTaskAdmin,
        layout: "/admin",
        type: 1,
      },
      {
        path: "/daily-feedback",
        name: "Daily Feedback",
        icon: "fa fa-comments",
        component: DailyFeedback,
        layout: "/admin",
        type: 1,
      },
    ],
  },
  {
    path: "/session",
    name: "Live session",
    icon: "fa fa-video-camera",
    component: session,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/notification",
    name: "Notification",
    icon: "fa fa-bell",
    component: notification,
    layout: "/admin",
    type: 1,
  },
  {
    path: "/videos",
    name: "PTE Secret Strategy Videos",
    icon: "fa fa-youtube-play",
    component: Video,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/help",
    name: "Help",
    icon: "fa fa-youtube-play",
    component: Help,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/zoom",
    name: "Zoom Meeting",
    icon: "fa fa-youtube-play",
    component: Zoom,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/transaction",
    name: "Transactions",
    icon: "fa fa-retweet",
    component: Transaction,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/subscription",
    name: "Videos",
    icon: "fa fa-youtube-play",
    component: Subscription,
    layout: "/sub",
    type: 2,
  },
  {
    path: "sub/payment/form/:id",
    name: "PaymentForm",
    icon: "fa fa-credit-card",
    component: PaymentForm,
    layout: "/admin",
    type: 2,
  },
  {
    path: "sub/success",
    name: "SubSuccess",
    icon: "fa fa-signal",
    component: SubSuccess,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/plans",
    name: "Plans",
    icon: "fa fa-signal",
    component: Plans,
    layout: "/admin",
    type: 2,
  },
  {
    path: "/password",
    name: "Change Password",
    icon: "fa fa-signal",
    component: Password,
    layout: "/admin",
    type: 2,
  },
  {
    path: "",
    name: "",
    icon: "fa fa-user",
    component: NotFoundAdmin,
    layout: "/admin",
    type: 2,
  },
  {
    path: "",
    name: "Login",
    mini: "L",
    type: 2,
    component: NotFound,
    layout: "/auth",
  },
];

export default routes;
